import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Text } from '@notino/react-styleguide';

import { IRating } from '@containers/ProductDetailContainer/model';

import messages from '../../../../../messages';
import { RatingRow } from '../styled';

import {
  AttributesReviews,
  ParamProgressWrapper,
  ParamValue,
  StyledProgressBar,
} from './styled';

interface IAttributesSummaryProps {
  ratings: IRating[];
}

export const AttributesSummary: React.FC<IAttributesSummaryProps> = ({
  ratings,
}) => {
  return (
    <AttributesReviews data-cypress="reviews-attributes">
      {ratings.map((rating) => (
        <RatingRow key={rating.id}>
          <ParamValue>
            <FormattedMessage {...messages[`ratingType${rating.ratingType}`]} />
          </ParamValue>
          <ParamProgressWrapper>
            <StyledProgressBar
              name={String(rating.id)}
              max={5}
              value={rating.preciseScore ?? 0}
              segments={true}
              height={4}
            />
            <Text typography="labelSmall400">
              {rating.preciseScore?.toFixed(1).replace('.', ',')} / 5
            </Text>
          </ParamProgressWrapper>
        </RatingRow>
      ))}
    </AttributesReviews>
  );
};
